globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.EmailingRecurringSettingsController = (function(superClass)
{
  utils.extend(EmailingRecurringSettingsController, superClass);

  function EmailingRecurringSettingsController() {
    return EmailingRecurringSettingsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(EmailingRecurringSettingsController.prototype, {
    init: function() {
      var $weekRankSelect = $('[name="business_services_emailing_settings_recurring_setting[week_rank_in_month]"]');
      var allWeekRankOptions = $weekRankSelect.find('option').clone();
      var bimonthlyWeekRankOptions = allWeekRankOptions.filter(function() {
        return $(this).val() === 'first' || $(this).val() === 'second';
      });

      function setWeekRankOptions(options) {
        var currentVal = $weekRankSelect.val();
        $weekRankSelect.empty().append(options.clone());
        if ($weekRankSelect.find('option[value="' + currentVal + '"]').length) {
          $weekRankSelect.val(currentVal);
        }
      }

      $("#monthly-radio-button").on('change', function(e) {
        $('.month-wrapper').hide()
        $('.bimonthly-wrapper').hide()
        $('.bimestrial-wrapper').hide()
        $('.quarterly-wrapper').css('display', 'contents')
        setWeekRankOptions(allWeekRankOptions);
      })
      $("#quarterly-radio-button").on('change', function(e) {
        $('.month-wrapper').css('display', 'contents')
        $('.quarterly-wrapper').hide()
        $('.bimonthly-wrapper').hide()
        $('.bimestrial-wrapper').hide()
        setWeekRankOptions(allWeekRankOptions);
      })
      $("#bimonthly-radio-button").on('change', function(e) {
        $('.month-wrapper').hide()
        $('.quarterly-wrapper').hide()
        $('.bimestrial-wrapper').hide()
        $('.bimonthly-wrapper').css('display', 'contents')
        setWeekRankOptions(bimonthlyWeekRankOptions);
      })
      $("#bimestrial-radio-button").on('change', function(e) {
        $('.month-wrapper').hide()
        $('.bimonthly-wrapper').hide()
        $('.quarterly-wrapper').hide()
        $('.bimestrial-wrapper').css('display', 'contents')
        setWeekRankOptions(allWeekRankOptions);
      })
      return EmailingRecurringSettingsController.__super__.init.apply(this, arguments);
    }
  });

  return EmailingRecurringSettingsController;

})(appCustomerSpace.Controllers.Settings.MainController);
